<template>
  <div class="csbox">
    <transition name="fade">
      <div @touchend='end'
           @touchstart='start'
           @touchmove='move'
           class="swiper">
        <div @click="currentIndex==index?toorgan(item.oId):chooseItem(index)"
             v-for="(item, index) in lists"
             :style="config5[index]"
             class="t2b3b"
             :key="index">
          <img :src="item.logo_url"
               style="width: 100%; height: 100%;">
          <div class="t2b3box"
               v-show="currentIndex==index"
               @click="toorgan(item.oId)">
            <img src="../../assets/img/organ/jinru.png"
                 alt="">
            <span>进入机构主页</span>
          </div>
        </div>
      </div>
    </transition>
    <div class="tbleft tbbtn">
      <img src="../../assets/img/icon/bg-left.png"
           style="cursor: pointer;"
           @click="prev"
           alt="">
    </div>
    <div class="tbright tbbtn">
      <img src="../../assets/img/icon/bg-right.png"
           style="cursor: pointer;"
           @click="next"
           alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'zt',
  data () {
    return {
      loading: true,
      currentIndex: 3, //当前中间lists数组中index
      centerInfo: '', // 当前中间信息
      startX: '',
      endX: '',
      previous: 0,
      config5: [
        {
          id: '-A',
          position: 'absolute',
          width: '22%',
          height: '72%',
          top: '19.2%',
          left: '-22%',
          opacity: 0,
          zIndex: 0,
          transition: '.4s'
        },
        {
          id: 'A',
          position: 'absolute',
          width: '22%',
          height: '72%',
          top: '16%',
          left: '0%',
          opacity: 1,
          zIndex: 1,
          transition: '.4s'
        },
        {
          id: 'B',
          position: 'absolute',
          width: '28%',
          height: '82%',
          top: '10%',
          left: '13%',
          opacity: 1,
          zIndex: 2,
          transition: '.4s'
        },
        {
          id: 'center',
          position: 'absolute',
          width: '40%',
          height: '100%',
          top: '0px',
          left: '50%',
          marginLeft: '-20%',
          opacity: 1,
          zIndex: 3,
          transition: '.4s'
        },
        {
          id: 'D',
          position: 'absolute',
          width: '28%',
          height: '82%',
          top: '10%',
          left: '60%',
          opacity: 1,
          zIndex: 2,
          transition: '.4s'
        },
        {
          id: 'E',
          position: 'absolute',
          width: '22%',
          height: '72%',
          top: '16%',
          left: '78%',
          opacity: 1,
          zIndex: 1,
          transition: '.4s'
        },
        {
          id: 'E+',
          position: 'absolute',
          width: '22%',
          height: '72%',
          top: '19.2%',
          left: '100%',
          opacity: 0,
          zIndex: 0,
          transition: '.4s'
        }
      ],
      timeInterval: null,
      lists: []
    };
  },
  props: {
    autoplay: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    // 获取数据
    async getData () {
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 滑动上一个
    prev (index) {
      // this.lists.unshift(this.lists.pop());
      this.config5.push(this.config5.shift());
      this.currentIndex = this.currentIndex - 1;
      if (this.currentIndex < 0) {
        this.currentIndex = this.lists.length - 1;
      }
      this.centerCard();
      this.centerIndex('prev');
    },
    // 滑动下一个
    next () {
      // this.lists.push(this.lists.shift());
      this.config5.unshift(this.config5.pop());
      this.currentIndex = this.currentIndex + 1;
      if (this.currentIndex > this.lists.length - 1) {
        this.currentIndex = 0;
      }
      this.centerCard();
      this.centerIndex('next');
    },
    // 开始移动端滑动屏幕
    start (event) {
      this.startX = event.changedTouches[0].clientX;
      this.startY = event.changedTouches[0].clientY;
    },
    // 连续滑动
    move (event) {
      this.endY = event.changedTouches[0].clientY;
      this.endX = event.changedTouches[0].clientX;
      this.stopDefault(event);
      // 如果是滑动，注解（223行到231行）这段。如果是连续滑动，放开（223行到231行）注解
      this.interval = this.endX - this.startX;
      if (this.interval > 40) {
        this.startX = this.endX;
        this.prev();
      }
      if (this.interval < -40) {
        this.startX = this.endX;
        this.next();
      }
    },
    // 滑动
    end (event) {
      // 如果是滑动，放开（236行到238行）的注解。如果是连续滑动，注解（236行到238行）
      // this.endY = event.changedTouches[0].clientY;
      // this.endX = event.changedTouches[0].clientX;
      // this.formatSwiper();
    },
    formatSwiper () {
      if (this.startX > this.endX) {
        if (this.startX > this.endX + 40) {
          this.next();
        }
      } else {
        if (this.endX > this.startX + 40) {
          this.prev();
        }
      }
    },
    // 阻止touchmove的横向默认事件（ios快捷操作会关闭页面）
    stopDefault (event) {
      let differenceY = this.endY - this.startY;
      let differenceX = this.endX - this.startX;
      if (Math.abs(differenceX) > Math.abs(differenceY)) {
        event.preventDefault();
      }
    },
    // 当前lists在位置上的index（并非img数组的index）
    centerIndex (val) {
      if (val == 'prev') {
        for (let val of this.lists) {
          if (val.index == this.lists.length - 1) {
            val.index = 0;
          } else {
            val.index = val.index + 1;
          }
        }
      } else {
        for (let val of this.lists) {
          if (val.index == 0) {
            val.index = this.lists.length - 1;
          } else {
            val.index = val.index - 1;
          }
        }
      }
    },
    // 点击
    chooseItem (index) {
      let cycles = this.currentIndex
      if (index < cycles) {
        for (let i = 0; i < cycles - index; i++) {
          this.prev();
        }
      } else if (index > cycles) {
        for (let i = 0; i < index - cycles; i++) {
          this.next();
        }
      }
    },
    // 计算中间卡片信息
    centerCard () {
      if (this.lists[this.currentIndex]) {
        this.centerInfo = this.lists[this.currentIndex];
        this.$emit('change', this.lists[this.currentIndex].oId);
      }

      // this.$emit('centerInfo', this.centerInfo);
    },

    addCardStyle () {
      if (this.lists.length > 7) {
        let addtime = this.lists.length - 7;
        for (let i = 0; i < addtime; i++) {
          this.config5.push({
            id: 'center',
            position: 'absolute',
            width: '45%',
            height: '100%',
            top: '0px',
            left: '50%',
            marginLeft: '-22.5%',
            opacity: 0,
            transition: '.1s'
          });
        }
      }
    },
    toorgan (id) {
      window.open('/organDetail?id=' + id, '_blank')
    },
  },
  created () {
    this.httphelper
      .post('/api/CGPEnterPriseApi/GetOrganProjectList', {
        orgId: 0
      })
      .then(res => {
        if (res.data.code == 200 && res.data.data.organList.length > 0) {
          this.lists = res.data.data.organList
          if (this.lists.length < 8) {
            this.lists = this.lists.concat(this.lists).slice(0, 7)
          }
        }
      });
    this.getData();
    this.centerCard(); // 获取中间卡片信息
    this.addCardStyle();// 加入样式位置的index
    if (this.autoplay) {
      this.timeInterval = setInterval(() => {
        this.next()
      }, 3000)
    }
  },
  destroyed () {
    if (this.timeInterval != null) {
      clearInterval(this.timeInterval);
    }
  }
};

</script>

<style lang="less" scoped>
.swiper {
    width: 100%;
    height: 280px;
    position: relative;
    overflow: hidden;
    div {
        opacity: 0;
    }
}
.t2b3b {
    border-radius: 5px;
    position: relative;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.37);
    border-radius: 5px;
    overflow: hidden;
}
.t2b3box {
    width: 130px;
    height: 35px;
    background: #007380;
    border-radius: 5px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    padding: 0 15px 0 15px;
    box-sizing: border-box;
    cursor: pointer;
    z-index: 100;
    opacity: 1 !important;
}
.t2b3box img {
    width: 20px;
    height: 20px;
}
.csbox {
    position: relative;
}
.csbox .tbbtn {
    position: absolute;
    bottom: 110px;
}
.csbox .tbleft {
    left: -40px;
}
.csbox .tbright {
    right: -40px;
}
.csbox .tbbtn img {
    width: 37px;
    height: 37px;
}
</style>